/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

type VehicleMetadata = {
  makeId?: string;
  makeName?: string;
  modelId?: string;
  modelName?: string;
  vehicleTypeId?: string;
  vehicleTypeName?: string;
  year?: string;
};

export function createSharableLink(
  href: string,
  source: 'pdp' | 'shelf',
  vehicleId?: string,
  vehicleMetadata?: VehicleMetadata,
): string {
  const url = new URL(href);
  const [base] = href.split('?');

  url.searchParams.set('cmpid', `SPL:US:EN:AD:NL:1000000:GEN:${source}`);

  if (vehicleId && Number(vehicleId) > 0 && !url.searchParams.has('vehicleId')) {
    url.searchParams.set('vehicleId', vehicleId);
  }

  // Add vehicle metadata as query parameters
  if (vehicleMetadata) {
    Object.entries(vehicleMetadata).forEach(([key, value]) => {
      if (value && !url.searchParams.has(key)) {
        // Use encodeURIComponent to properly handle spaces and special characters
        const formattedValue = typeof value === 'string' ? encodeURIComponent(value) : value;
        url.searchParams.set(key, formattedValue);
      }
    });
  }

  const stringParams = decodeURIComponent(url.searchParams.toString());

  return `${base}?${stringParams}`;
}

export async function shareLink(
  showShareAPI: boolean | undefined,
  source: 'pdp' | 'shelf',
  vehicleId?: string,
  vehicleMetadata?: VehicleMetadata,
) {
  const sharableLink = createSharableLink(window.location.href, source, vehicleId, vehicleMetadata);

  try {
    if (showShareAPI) {
      await navigator.share({
        url: sharableLink,
      });
    } else {
      await navigator.clipboard.writeText(sharableLink);
    }
  } catch {
    //Determine what to do if none navigator APIS are available
  }
}
